module.exports = __webpack_public_path__ + "fde88d1c075e2faa897e05c86f65cad2.mp3";